module.exports = __webpack_public_path__ + "img/part3.647bb95e.png";